<div class="container-general-no-print w-100">
    <div *ngIf="date" class="date">
        <p class="mb-0 ls-label-small-semibold text-neutral-A1 bg-support-50" [innerHTML]="date | localizedDate: modelDate"></p>
    </div>
    <div *ngIf="title" class="title">
        <h3 class="mt-0 mb-2 ls-h3-item-title cursor-pointer text-brand-10" [innerHTML]="title"></h3>
    </div>
    <div *ngIf="subtitle" class="subtitle">
        <p class="mb-2 ls-label-small-semibold text-uppercase text-brand-10" [innerHTML]="subtitle"></p>
    </div>
    <div *ngIf="taxonomy" class="taxonomies">
        <p class="mb-2 ls-label-small-semibold text-uppercase text-brand-10" [innerHTML]="taxonomy"></p>
    </div>
    <div *ngIf="taxonomies && taxonomies.length" class="taxonomies d-flex" style="gap: 0 3px;">
        <p class="mb-2 ls-label-small-semibold text-uppercase text-brand-10"
            *ngFor="let tax of taxonomies; let idx = index;"
            [innerHTML]="idx !== (taxonomies.length - 1) ? tax.name + ', ' : tax.name">
        </p>
    </div>
    <div *ngIf="taxonomies2 && taxonomies2.length" class="taxonomies d-flex" style="gap: 0 3px;">
        <p class="mb-2 ls-label-small-semibold text-uppercase text-brand-10"
            *ngFor="let tax of taxonomies2; let idx = index;"
            [innerHTML]="idx !== (taxonomies2.length - 1) ? tax.name + ', ' : tax.name">
        </p>
    </div>
    <div *ngIf="imageUrl" class="image mt-3 mb-5">
        <img loading="lazy" [src]="imageUrl" alt="LUMSA">
    </div>
    <div *ngIf="iconUrl" class="icon mt-3 mb-5">
        <img loading="lazy" [src]="iconUrl" alt="LUMSA">
    </div>
    <div *ngIf="description" class="description">
        <p class="mt-4 ls-label-small-semibold text-uppercase text-brand-10" [innerHTML]="description"></p>
    </div>
</div>